import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02fd459e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

import ScPage from '@/components/common/page/ScPage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'View',
  props: {
    content: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ScPage, null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "content",
        innerHTML: _ctx.content
      }, null, 8, _hoisted_1)
    ]),
    _: 1
  }))
}
}

})